'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasCellMetadata = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var hasCellMetadata = exports.hasCellMetadata = function hasCellMetadata(metadataCoordinates, cellCoordinates) {
  if (R.propOr('OBS_VALUE', 'OBS_ATTRIBUTES', cellCoordinates) !== 'OBS_VALUE') {
    return false;
  }
  return R.pipe(R.find(function (coordinates) {
    var mergedCoord = R.mergeLeft(coordinates, cellCoordinates);
    return !R.isEmpty(coordinates) && R.equals(mergedCoord, cellCoordinates);
  }), R.complement(R.isNil))(metadataCoordinates);
};